var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.version == 1)?_c('DetailV1'):_vm._e(),(_vm.version == 2)?_c('DetailV2'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }